import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import qs from 'qs'
import { displayVariations, updateComponentList, updateCalculator } from '../../../actions/calculator'
import { getNetPrice, getTax, device } from '../../../utils/helpers'
import AddIcon from '../../UI/Icons/AddIcon'
import EditIcon from '../../UI/Icons/EditIcon'
import InfoIcon from '../../UI/Icons/InfoIcon'
import RemoveIcon from '../../UI/Icons/CloseIcon'
import ConfirmPopup from '../../UI/Modals/ConfirmPopup'
import Modal from 'react-modal'
import { mapping } from '../../../utils/info_mappings.js'
import { withRouter } from 'react-router-dom'

const Wrapper = styled.div`
  width: 132px;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0 10px;
  margin-bottom: 15px;

  @media ${device.tablet} {
    width: 6.875vw;
    margin: 0 0.5208333333333334vw;
    margin-bottom: 0.78125vw;
  }
`

const Blank = styled.div`
  width: 132px;
  height: 96px;
  background: #E2E2E2;
  margin: 0 10px;
  margin-bottom: 15px;

  @media ${device.tablet} {
    ${'' /* width: 132px;
    margin: 0 10px;
    margin-bottom: 15px; */}
    width: 6.875vw;
    height: 5vw;
    margin: 0 0.5208333333333334vw;
    margin-bottom: 0.78125vw;
  }

  ${'' /* @media ${device.laptop} {
    width: 90px;
    height: 65px;
    margin: 0 5px;
    margin-bottom: 10px;
  }

  @media ${device.laptopL} {
    width: 132px;
    height: 96px;
    margin: 0 10px;
    margin-bottom: 15px;
  } */}
`

const ComponentName = styled.div`
  background: #e2e2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  width: 100%;
  height: 65px;
  line-height: 1.2em;
  padding: 0 3px;
  box-sizing: border-box;
  color: ${props => props.type === 3 ? '#999999' : '#4d4d4d'};

  @media ${device.tablet} {
    height: 3.385416666666667vw;
    font-size: 0.8575vw;
  }
`

const Meta = styled.div`
  background: ${props => props.theme.color.bgYellow};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  font-family: 'BarlowSemiBold';
  text-transform: uppercase;
  width: 100%;
  height: 65px;
  color: #fff;
  line-height: 1.2em;

  @media ${device.tablet} {
    height: 3.385416666666667vw;
    font-size: 0.7291666666666667vw;
  }
`

const Controls = styled.div`
  height: 31px;
  display: flex;

  @media ${device.tablet} {
    height: 1.6145833333333335vw;
  }
`

const InfoControl = styled.div`
  ${''/* Type 1 has only info so its width is 100% */}
  width: ${props => props.type !== 1 ? '20%' : '100%'};
  background: ${props => props.type !== 1 ? '#999999' : '#4d4d4d'};
  background: ${props => props.type === 3 && '#CCCCCC'};
  background: ${props => props.hover && props.theme.color.hoverPrimary};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background: ${props => props.theme.color.hoverPrimary};
    cursor: pointer;
  }
`

const EditControl = styled.div`
  width: 80%;
  background: ${props => props.hover ? props.theme.color.hoverPrimary : '#4d4d4d'};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background: ${props => props.theme.color.hoverPrimary};
    cursor: pointer;
  }
`

const AddControl = styled.div`
  width: 80%;
  background: #999999;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background: ${props => props.theme.color.hoverPrimary};
    cursor: pointer;
  }
`

const Add = styled(AddIcon)`
  width: 15px;

  @media ${device.tablet} {
    ${''/* width: 15px; */}
    width: 0.78125vw;
  }
`

const Info = styled(InfoIcon)`
  width: 4px;

  @media ${device.tablet} {
  ${''/* width: 4px; */}
    width: 0.20833333333333334vw;
  }
`

const Edit = styled(EditIcon)`
  width: 15px;

  @media ${device.tablet} {
    ${''/* width: 15px; */}
    width: 0.78125vw;
  }
`

const Remove = styled(RemoveIcon)`
  position: absolute;
  top: 1px;
  right: 1px;
  cursor: pointer;
  width: 15px;

  @media ${device.tablet} {
    ${''/* width: 15px; */}
    width: 0.78125vw;
  }
`

let CustomizeComponent = class CustomizeComponent extends Component {
  state = {
    hoverInfo: false,
    hoverEdit: false,
    hoverAdd: false,
    hoverRemove: false,
    infoOpen: false,
    removeOpen: false
  }

  hoverInfoStart () {
    this.setState({ hoverInfo: true })
  }

  hoverInfoEnd () {
    this.setState({ hoverInfo: false })
  }

  hoverEditStart () {
    this.setState({ hoverEdit: true })
  }

  hoverEditEnd () {
    this.setState({ hoverEdit: false })
  }

  hoverAddStart () {
    this.setState({ hoverAdd: true })
  }

  hoverAddEnd () {
    this.setState({ hoverAdd: false })
  }

  hoverRemoveStart () {
    this.setState({ hoverRemove: true })
  }

  hoverRemoveEnd () {
    this.setState({ hoverRemove: false })
  }

  handleEditClick (name) {
    let { components, options, details } = this.props
    console.log(details)
    if (details && options.length < 1) {
      let componentsCopy = [...components]
      this.props.displayVariations(name)
      // Update componentsList to add a type 5 for mobile
      const index = _.findIndex(componentsCopy, { name })
      componentsCopy.splice(index + 1, 0, { type: 5 })
      this.props.updateComponentList(componentsCopy)
    }
  }

  handleAddClick (name) {
    // Convert the component from type 3 to 4
    let { components, step, options, details } = this.props
    // The damn thing will not update unless it
    // is new since state is IMMUTABLE!
    let componentsCopy = [...components]
    console.log(details)
    if (details) { // If there are variations
      this.props.displayVariations(name)
      // Update componentsList to add a type 5 for mobile
      const index = _.findIndex(componentsCopy, { name })
      componentsCopy.splice(index + 1, 0, { type: 5 })
      this.props.updateComponentList(componentsCopy)
    } else { // This is if it doesn't have variations
      let toUpdate = _.find(componentsCopy, { name })
      toUpdate.type = 4
      // Setting to true is what renders it in the calculator sidebar
      toUpdate.selected = true
      const index = _.findIndex(componentsCopy, { name })
      componentsCopy[index] = toUpdate
      // Sum of all components price
      const totalPrice = _.reduce(componentsCopy,
        (sum, component) => component.selected ? sum + component.price : sum,
        0)
      // Make it false since hovering over it makes it stay
      this.setState({ hoverAdd: false })
      const data = {
        active: true,
        visited: true,
        price: totalPrice,
        net: getNetPrice(totalPrice),
        tax: getTax(totalPrice),
        components: componentsCopy,
        selected: true
      }
      // Update the state of the calculator
      this.props.updateCalculator(step, data)
      // Update the component list to reflect the new type
      this.props.updateComponentList(componentsCopy)
    }
  }

  handleRemoveClick (name) {
    // Convert the component from type 4 to 3
    let { components, step } = this.props
    // The damn thing will not update unless it
    // is new since state is IMMUTABLE!
    let componentsCopy = [...components]
    let toUpdate = _.find(componentsCopy, { name })
    toUpdate.type = 3
    // Setting to false hides it from the calculator sidebar
    toUpdate.selected = false
    const index = _.findIndex(componentsCopy, { name })
    componentsCopy[index] = toUpdate
    // Sum of all components price
    const totalPrice = _.reduce(componentsCopy,
      (sum, component) => component.selected ? sum + component.price : sum,
      0)
    // Make it false since hovering over it makes it stay
    this.setState({ hoverRemove: false })
    const data = {
      active: true,
      visited: true,
      price: totalPrice,
      net: getNetPrice(totalPrice),
      tax: getTax(totalPrice),
      components: componentsCopy,
      selected: false
    }
    // Update the state of the calculator
    this.props.updateCalculator(step, data)
    // Update the component list to reflect the new type
    this.props.updateComponentList(componentsCopy)
  }

  // Render the text that shows up when icons are hovered over
  renderMeta (price) {
    const { hoverInfo, hoverEdit, hoverAdd, hoverRemove } = this.state
    if (hoverInfo) {
      return <span>Scheda <br /> Tecnica</span>
    } else if (hoverEdit) {
      return <span>Modifica</span>
    } else if (hoverAdd) {
      return <span>
        AGGIUNGI<br />COMPONENTE<br />+ {price} €
      </span>
    } else if (hoverRemove) {
      return <span>Rimouvi</span>
    }
  }

  openInfoModal () {
    this.setState({ infoOpen: true })
  }

  closeInfoModal () {
    this.setState({ infoOpen: false })
  }

  openRemoveModal (name) {
    this.setState({ removeOpen: true, name })
  }

  closeRemoveModal () {
    this.setState({ removeOpen: false })
  }

  render () {
    let { type, name, component } = this.props
    const variant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    const { hoverInfo, hoverEdit, hoverAdd, hoverRemove } = this.state
    let nameCopy = name && name.toLowerCase().replace(/\s/g, '').replace(/-/g, '').replace(/\(\w+\)/g, '')
    const info = nameCopy && nameCopy.includes('campo') ? 'campo' + variant : nameCopy // Convert name of component
    const InfoPopup = mapping[info] // Get instance of the component
    if (type !== 0) {
      return (
        <Wrapper>
          {/* Show remove icon only if type 4 */}
          {type === 4 && <Remove
            fill='#4d4d4d'
            onMouseEnter={this.hoverRemoveStart.bind(this)}
            onMouseLeave={this.hoverRemoveEnd.bind(this)}
            onClick={this.openRemoveModal.bind(this, name)}
          />}

          {/* Show meta when hovered else component name */}
          {hoverInfo || hoverEdit || hoverAdd || hoverRemove
            ? <Meta>
              {this.renderMeta(component.price)}
            </Meta>
            : <ComponentName type={type}>
              {name}
            </ComponentName>
          }
          <Controls>
            {/* {this.renderControls()} */}
            {/* Edit icon for type 2 and 4 */}
            {(type === 2 || type === 4) && <EditControl
              onMouseEnter={this.hoverEditStart.bind(this)}
              onMouseLeave={this.hoverEditEnd.bind(this)}
              onClick={this.handleEditClick.bind(this, name)}
              type={type}
              hover={hoverRemove}
            >
              {!hoverRemove && <Edit fill='#fff' />}
            </EditControl>}

            {(type === 3) && <AddControl
              onMouseEnter={this.hoverAddStart.bind(this)}
              onMouseLeave={this.hoverAddEnd.bind(this)}
              onClick={this.handleAddClick.bind(this, name)}
              type={type}
            >
              <Add fill='#fff' />
            </AddControl>}

            <InfoControl
              onMouseEnter={this.hoverInfoStart.bind(this)}
              onMouseLeave={this.hoverInfoEnd.bind(this)}
              type={type}
              hover={hoverRemove}
              onClick={this.openInfoModal.bind(this)}
            >
              {/* When remove icon is hovered, hide the info icon */}
              {!hoverRemove && <Info fill='#fff' />}
            </InfoControl>
          </Controls>
          {/* Info Popup */}
          <Modal
            isOpen={this.state.infoOpen}
            className='Modal'
            overlayClassName='Overlay'
          >
            <InfoPopup
              closeModal={this.closeInfoModal.bind(this)}
            />
          </Modal>
          {/* Remove Component Popup */}
          <Modal
            isOpen={this.state.removeOpen}
            className='Modal2'
            overlayClassName='Overlay2'
          >
            <ConfirmPopup
              title='SEI SICURO DI;VOLER RIMUOVERE;QUESTO COMPONENTE?'
              closeModal={this.closeRemoveModal.bind(this)}
              confirm={this.handleRemoveClick.bind(this, this.state.name)}
            />
          </Modal>
        </Wrapper>
      )
    } else {
      return (
        <Blank />
      )
    }
  }
}

CustomizeComponent.propTypes = {
  /**
   * Takes 1, 2, 3 or 4
   * Type 1 - Fixed component, cannot be customized, can only view info
   * Type 2 - Fixed component, can be customized and can view info
   * Type 3 - Add-able component, component that can be optionally added and info can be seen
   * Type 4 - Add-able component that has been added which now can be removed
   */
  type: PropTypes.number,
  /**
   * Name of the component
   */
  name: PropTypes.string
}

CustomizeComponent.defaultProps = {
  type: 1
}

function mapStateToProps (state) {
  return {
    components: state.calculator.components,
    options: state.calculator.options
  }
}

CustomizeComponent = withRouter(CustomizeComponent)

export default connect(mapStateToProps, { displayVariations, updateComponentList, updateCalculator })(CustomizeComponent)



// WEBPACK FOOTER //
// ./src/components/Calculator/Configurator/CustomizeComponent.js